import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginFormComponent } from './login-form.component';
import { TranslateModule, AlertListModule, LoaderModule } from '@xref/ngx';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { OmniLoaderModule } from '../../../../components/omni-loader/omni-loader.module';
import { ButtonModule} from '@xref/xref-lib';

@NgModule({
    declarations: [LoginFormComponent],
    imports: [
        CommonModule,
        TranslateModule,
        OmniLoaderModule,
        RouterModule,
        FormsModule,
        AlertListModule,
        ButtonModule
    ],
    exports: [
        LoginFormComponent
    ]
})
export class LoginFormModule { }
